import Icon from '$store/components/ui/Icon.tsx'
import { TimerConfig } from '$store/loaders/timers.tsx'
import { useTimer } from '$store/sdk/useTimer.ts'

export interface Props {
    timers: TimerConfig[]
}

function PDPTimer({ timers = [] }: Props) {
    // Pode ser útil para definir a ordem de prioridade (por enquanto só pega o primeiro elemento)
    const timer = timers.find(() => true)

    if (!timer) return null

    const { start, end, layout } = timer

    const startDate = (start ? new Date(start) : new Date()).getTime()
    const endDate = new Date(end).getTime()

    const timeLeft = useTimer({ startDate, endDate })

    if (timeLeft.status !== 'in-progress') return null

    const hours = timeLeft.hours.toString().padStart(2, '0')
    const minutes = timeLeft.minutes.toString().padStart(2, '0')
    const seconds = timeLeft.seconds.toString().padStart(2, '0')

    return (
        <div
            class='flex items-center justify-center h-[53px] max-w-[455px] gap-1 leading-none text-white bg-primary md:rounded-md mb-2'
            style={{ backgroundColor: layout?.bgColor, color: layout?.textColor }}
        >
            <span class='text-sm font-bold uppercase leading-none'>Termina em:</span>{' '}
            <Icon id='Timer' width={24} height={23} class='text-white' />{' '}
            <span class='min-w-[70px] text-[17px] font-bold leading-none'>
                {hours}:{minutes}:{seconds}
            </span>
        </div>
    )
}

export default PDPTimer
